import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../App.css";
// import Logo from "../assets/images/logo.png";
import Dashboard from "../assets/images/Dashboard.jpg";
import Stores from "../assets/images/Store.png";
import Category from "../assets/images/Categories.png";
import Logo from "../assets/images/bayin.png";
import Order from "../assets/images/Order.png";
import Logout from "../assets/images/Logout.png";
import Report from "../assets/images/report.png";
import Setting from "../assets/images/settings.png";
import Modal from 'react-bootstrap/Modal';
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { ownerLogout } from "../redux/actions/authAction";
import { io } from "socket.io-client";




const SideNav = () => {
    let path = window.location.href.split('/');
    let pathLength = parseInt(path.length) - 1;
    let pathMatch = path[pathLength];

    const [Logoutshow, setShow] = useState(false);
    const handleLogoutClose = () => setShow(false);
    const handleLogoutShow = () => setShow(true);

    const socketRef = useRef();
    const SOCKET_SERVER_URL = 'https://bayin.app:4000';
  
    

    const dispatch = useDispatch();
    const navigate = useNavigate()
    const handleLogout = () => {
        dispatch(ownerLogout()).then(res => {

            if (res.status === 200) {
                toast.success(res.message, {
                    position: toast.POSITION.TOP_RIGHT,
                });
              
                socketRef.current = io(SOCKET_SERVER_URL, {
                    transports: ['websocket'],
                    reconnection: true,
                    reconnectionAttempts: Infinity,
                    reconnectionDelay: 1000,
                    reconnectionDelayMax: 5000,
                    randomizationFactor: 0.5,
                  });
               
                  socketRef.current.on('disconnect', (reason) => {
                    // console.log(`Socket disconnected: ${reason}`);
                  });
              
                //   return () => {
                    localStorage.clear()
                    navigate('/')
                    socketRef.current.disconnect();
                    // window.location.reload()
                //   };
                
            } else {
                toast.error(res.message, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        })
    }

    return (
        <div>
            <div className="SidenavArea">
                <figure>
                    <img src={Logo} />
                </figure>
                <ul>
                    <li className={pathMatch == "dashboard" ? "active" : ''}>
                        <Link to="/dashboard">
                            <span class="Icon"> <img src={Dashboard} /></span>
                            Dashboard
                        </Link>
                    </li>
                    {/* <li className={(pathMatch == "customer-management" || pathMatch == "customer-details" || pathMatch == "customer-add" || pathMatch == "customer-edit") ? "active" : ''}>
                        <Link to="/customer-management">
                            <span class="Icon"> <img src={Customers} /></span>
                             Customers 
                        </Link>
                    </li> */}
                    <li className={(pathMatch == "my-store" || pathMatch == "edit-my-store") ? "active" : ''}>
                        <Link to="/my-store">
                            <span class="Icon"> <img src={Stores} /></span>
                            Store
                        </Link>
                    </li>
                    <li className={(pathMatch == "product-management" || pathMatch == "product-add" || pathMatch == "product-edit") ? "active" : ''}>
                        <Link to="/product-management">
                            <span class="Icon"> <img src={Category} /></span>
                            Product
                        </Link>
                    </li>
                    <li className={(pathMatch == "order-management" || pathMatch == "order-details") ? "active" : ''}>
                        <Link to="/order-management">
                            <span class="Icon"> <img src={Order} /></span>
                            Order
                        </Link>
                    </li>
                    <li className={(pathMatch == "setting") ? "active" : ''}>
                        <Link to="/setting">
                            <span class="Icon"> <img src={Setting} /></span>
                            Settings
                        </Link>
                    </li>
                    <li className={(pathMatch == "Report-management") ? "active" : ''}>
                        <Link to="/Report-management">
                            <span class="Icon"> <img src={Report} /></span>
                            Reports
                        </Link>
                    </li>
                    <li className={(pathMatch == "") ? "active" : ''}>
                        <a href="javascript:void(0)" onClick={handleLogoutShow}>
                            <span class="Icon"> <img src={Logout} /></span>
                            Logout
                        </a>
                    </li>
                </ul>
            </div>
            <div >
                <Modal show={Logoutshow} onHide={handleLogoutClose} className="ModalBox ">
                    <Modal.Body>
                        <div class="Decline">
                            <button class="CloseModal" onClick={handleLogoutClose} >×</button>
                            <h3>Logout</h3>
                            <figure>
                                <img src={Logout} />
                            </figure>
                            <p>Are you sure you want to Logout this Panel?</p>
                            <h4>
                                <button class="Cancel" onClick={handleLogoutClose}>Cancel</button>
                                <button onClick={() => handleLogout()}>Logout</button>
                            </h4>
                        </div>
                    </Modal.Body>
                </Modal>



            </div>
        </div>
    );
}
export default SideNav